import { render, staticRenderFns } from "./krisenintervention.vue?vue&type=template&id=2d5f0706&scoped=true&lang=pug"
import script from "./krisenintervention.vue?vue&type=script&lang=ts"
export * from "./krisenintervention.vue?vue&type=script&lang=ts"
import style0 from "./krisenintervention.vue?vue&type=style&index=0&id=2d5f0706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f0706",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VCol: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VCol.js').default,VRow: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VRow.js').default,VImg: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VImg/VImg.js').default,VIcon: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VBtn: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VBtn/VBtn.js').default,VCard: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VCard/VCard.js').default,VListItemAvatar: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VList/VListItemAvatar.js').default,VListItem: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VList/VListItem.js').default,VList: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VList/VList.js').default,VContainer: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VContainer.js').default})
